export default "__VITE_ASSET__GwzX6NzE__"